export const DEFAULT_ACTIVATION_WINDOW_HOURS = 2;

export const DEFAULT_ROLE_RATES = {
  CNA: { billRate: 0, payRate: 0 },
  LVN: { billRate: 0, payRate: 0 },
  RN: { billRate: 0, payRate: 0 },
  MED_AIDE: { billRate: 0, payRate: 0 },
  CARE_GIVER: { billRate: 0, payRate: 0 },
};

export function normalizeFacilityId(value) {
  return String(value || "").trim().toLowerCase() || null;
}

export function normalizeFacilityName(value) {
  return String(value || "").trim();
}

export function normalizeRoleKey(role) {
  return String(role || "")
    .trim()
    .toUpperCase()
    .replace(/[\s-]+/g, "_")
    .replace(/_+/g, "_");
}

export function normalizeRate(value) {
  const rate = Number(value || 0);
  return Number.isFinite(rate) ? rate : 0;
}

export function normalizeFacilityRates(rates = {}) {
  const normalized = { ...DEFAULT_ROLE_RATES };

  Object.entries(rates || {}).forEach(([role, values]) => {
    const key = normalizeRoleKey(role);

    normalized[key] = {
      billRate: normalizeRate(values?.billRate),
      payRate: normalizeRate(values?.payRate),
    };
  });

  return normalized;
}

export function getFacilityRoleRate(facilityProfile, role) {
  const key = normalizeRoleKey(role);
  const rates = normalizeFacilityRates(facilityProfile?.billingRates || facilityProfile?.rates);

  return rates[key] || { billRate: 0, payRate: 0 };
}

export function getFacilityActivationWindowHours(facilityProfile) {
  const value = Number(facilityProfile?.activationWindowHours);

  if (!Number.isFinite(value) || value <= 0) {
    return DEFAULT_ACTIVATION_WINDOW_HOURS;
  }

  return value;
}

export function normalizeFacilityProfile(profile = {}) {
  return {
    ...profile,
    facilityId: normalizeFacilityId(profile.facilityId || profile.id),
    name: normalizeFacilityName(profile.name || profile.facilityName),
    type: String(profile.type || "snf").toLowerCase(),
    status: String(profile.status || "active").toLowerCase(),
    activationWindowHours: getFacilityActivationWindowHours(profile),
    billingRates: profile.billingRates || {},
    ...(profile.rates ? { rates: normalizeFacilityRates(profile.rates) } : {}),
  };
}